import Ingestion from "../../../utils/services/project/metering/ingestionService";
import crudTemplate from "../../../templates/crudTemplate";
import Transmission from "../../../utils/services/project/metering/transmissionService";

let crud = crudTemplate(Ingestion);

const state = {
  ...crud.state,
  filter_type: [
    { value: "jsonpath", text: "jsonpath" },
    { value: "xpath", text: "xpath" },
    { value: "regex", text: "regex" }
  ]
};

const getters = {
  ...crud.getters,
  getList(state) {
    //let project = rootGetters["projectStore/getCurrentItem"];
    return crud.getters.getList(state);
  },
  getItem(state) {
    let item = crud.getters.getItem(state);
    item.project_id = item._project && item._project.id;
    return item;
  },
  getMonitoringMode() {
    //0=self-learning/1=max-eight-hours/2=max-twelve-hours/3=max-24-hours/4=max-24-hours-delayed-error
    return [
      { value: 0, text: "ingestions.monitoring-modes.self-learning" },
      { value: 1, text: "ingestions.monitoring-modes.max-eight-hours" },
      { value: 2, text: "ingestions.monitoring-modes.max-twelve-hours" },
      { value: 3, text: "ingestions.monitoring-modes.max-24-hours" },
      {
        value: 4,
        text: "ingestions.monitoring-modes.max-24-hours-delayed-error"
      }
    ];
  },
  getFilterTypes() {
    return state.filter_type;
  }
};

const actions = {
  ...crud.actions,
  testFilter(_, { params, errorHandler = () => {}, onSuccess = () => {} }) {
    return Transmission.testFilter(
      {
        ...params
      },
      onSuccess,
      () => {},
      errorHandler
    );
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
